import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import moment from 'moment';
import { CompanyDetailsInterface } from '../../services/exports/Interfaces';

interface Props {
  company: CompanyDetailsInterface;
}
export default function useLoyaltyProgram(props?: Props) {
  const { company: defaultCompany } = useSelector((store: StoreInterface) => store.initialData);
  const company = props?.company ?? defaultCompany;

  const data = company?.loyalty_program;

  return {
    isActive: data && (!data.end_date || moment(data.end_date).isAfter(moment())),
    loyalty: data,
    hasLoyaltyPromotion: !!data,
    reward: data?.reward,
    rewardThreshold: data?.reward_threshold,
    isPerEligibleItem: data?.is_per_item,
  };
}
